<template>
  <dd-dialog-modal
    :title="title"
    :description="description"
    :visible="visible"
    @cancel="$emit('cancel')"
    v-bind="$attrs"
  >
    <template v-slot:buttons>
      <dd-button type="primary" outline @click="$emit('cancel')">Annuleer</dd-button>
      <dd-button type="primary" @click="deleteTask" :loading="loading">Verwijder</dd-button>
    </template>
  </dd-dialog-modal>
</template>

<script>
import TaskApi from "~/api/task";

export default {
  name: "DeleteModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    task: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Taak verwijderen'
    },
    description: {
      type: String,
      default: 'Weet je zeker dat je deze taak wil verwijderen?'
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    canDeleteTask() {
      return this.$store.state.permissions.delete_task === true;
    },
  },
  methods: {
    deleteTask() {
      if (this.canDeleteTask !== true) {
        this.$notification['error']({
          message: "Kan taak niet verwijderen",
          description: "Je hebt geen rechten om deze taak te verwijderen"
        });

        this.$emit('cancel');
        return;
      }

      if (this.task && this.task.id
          && this.visible === true
      ) {
        this.loading = true;

        TaskApi.delete(this.task.id)
            .then((response) => {
              this.$notification['success']({
                message: "Taak verwijderd",
                description: `${this.task.content || 'Taak'} is verwijderd`,
              });

              this.$emit('deleted', this.task.id);
            })
            .catch((error) => {
              this.$notification['error']({
                message: "Kon de taak niet verwijderen",
                description: "Er is iets fout gegaan bij het verwijderen van de taak"
              })
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
  },
};
</script>
